<template>
    <div ref="container" style="display: block;width: 100%;height: 100%;position: relative"> <slot></slot></div>
</template>


<script>
    import Vue from 'vue'
    import StackedAreaChart from './stacked-area-chart.js'

    export default {
        name:"stacked-area-chart",
        //передоваемые параметры
        props: {
            data: {
                type: Array,
                default: () => ([])
            },
            option: {
                type: Object,
                default: () => ({})
            }
        },
        // локальное состояние
        data() {
            return {
                defOprion: {
                    margin: {
                        left: 60,
                        right: 20,
                        top: 20,
                        bottom: 20
                    },
                    axisLabels: {
                        x: "Axis X",
                        y: "Axis Y"
                    },
                    fill: false,
                    isDiscrete: true,
                    maxZoom: 2,
                    xAxis: "x"
                }
            }
        },

        mounted() {
            this.updateChart();
            window.addEventListener('resize', this.updateChart);
        },

        //вычисляемые свойства (https://ru.vuejs.org/v2/guide/computed.html#Вычисляемые-свойства)
        computed: {}
        ,
        //Методы для изменения локального состояния.Ограничения (https://ru.vuejs.org/v2/guide/list.html#Отслеживание-изменений-в-массивах)
        methods: {
            updateChart() {
                const options = {
                    width: this.$refs.container.clientWidth,
                    height: this.$refs.container.clientHeight,
                    container: this.$refs.container
                };

                for (let i in this.option)
                    if (this.option.hasOwnProperty(i) && 'undefined' !== typeof this.option[i])
                        options[i] = this.option[i];

                for (let i in this.defOprion)
                    if (this.defOprion.hasOwnProperty(i) && 'undefined' !== typeof this.defOprion[i] && 'undefined' === typeof options[i])
                        options[i] = this.defOprion[i];

                StackedAreaChart(this.data, options);
            }
        },

        components: {},

        watch: {
            data() {
                this.updateChart();
            },
            option() {
                this.updateChart();
            }
        }
    }
</script>

<style>
    .area {
        clip-path: url(#clip);
    }

    .zoom {
        fill: none;
        pointer-events: all;
    }

    .toolTip {
        position: absolute;
        display: none;
        height: auto;
        text-align: left;
        padding: 5pt 10pt;
    }

    .blackTooltip {
        background: none repeat scroll 0 0 black;
        border: 1px solid black;
        color: white;
    }

    .whiteTooltip {
        background: #6435C9;
        border: 1px solid #6435C9;
        border-radius: 10pt;
        color: white;
    }
</style>